module.exports = __webpack_public_path__ + "assets/img/C3.3b2e4d1f.jpg";